import styled from "@emotion/styled";
import React, { useState } from "react";
import IcForwad from "../../../../assets/images/forward.png";

const NavegationBar = ({ config, currentValue, total, onNavItemSelect }) => {

    const Wrapper = styled.div`
        width: calc(100% - 4vh);
        padding: 2vh;
        display: flex;
        position: relative;
        background: white;
        justify-content: center;
        flex-direction: row;
        align-items: center;
        overflow-x: auto;
        overflow-y: hidden;

        @media (max-width: 426px) {
            width: calc(100% - 1vh);
            padding: 1.5vh 0.5vh;
        }
    `;

    const Circle = {
        display: "flex",
        width: config?.mediaQueries?.maxWidth426 ? "4.5vh" : "5vh",
        height: config?.mediaQueries?.maxWidth426 ? "4.5vh" : "5vh",
        minWidth: config?.mediaQueries?.maxWidth426 ? "4.5vh" : "5vh",
        minHeight: config?.mediaQueries?.maxWidth426 ? "4vh" : "5vh",
        fontSize: config?.mediaQueries?.maxWidth426 ? "2.5vh" : "3.5vh",
        borderRadius: "50%",
        background: "white",
        border: "0.2vh solid #3c3c3b",
        color: "#3c3c3b",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
    }

    const SelectedCircle = {
        ...Circle,
        background: "#3c3c3b",
        color: "white",
    }

    const Line = {
        width: config?.mediaQueries?.maxWidth426 ? "1.5vh" : "3vh",
        height: "0.3vh",
        background: "lightgray",
    }

    const SelectedLine = {
        ...Line,
        background: "gray",
    }

    const Arrow = {
        ...SelectedCircle,
        borderRadius: "1vh",
        margin: config?.mediaQueries?.maxWidth426 ? "0 1.5vh" : "0 3vh"
    }

    const Icon = styled.img`
        ${props => `
            width: 40%;
            height: auto;
            margin: auto;
            ${props?.rotated ? " transform: rotate(180deg);" : null}
        `}
    `;

    const loadItems = () => {
        var items = [];
        for (var i = 0; i < total; i++) {
            const finalI = i;

            // Line
            if (i > 0) {
                items.push(
                    <div
                        key={"navLine" + finalI}
                        style={i <= currentValue ? SelectedLine : Line} />
                );
            }

            // Index element
            items.push(
                <div
                    key={"navItem" + finalI}
                    style={i <= currentValue ? SelectedCircle : Circle}
                    onClick={() => { onNavItemSelect(finalI) }}>
                    {i + 1}
                </div>
            );
        }
        return items;
    }

    return (
        <Wrapper>
            <div style={Arrow} onClick={() => { onNavItemSelect(currentValue - 1) }}>
                <Icon src={IcForwad} rotated={true} />
            </div>
            {loadItems()}
            <div style={Arrow} onClick={() => { onNavItemSelect(currentValue + 1) }}>
                <Icon src={IcForwad} />
            </div>
        </Wrapper>
    );
};

export default NavegationBar;
